import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 6.75C6.5 4.95507 7.95507 3.5 9.75 3.5C11.5449 3.5 13 4.95507 13 6.75C13 8.54493 11.5449 10 9.75 10C7.95507 10 6.5 8.54493 6.5 6.75ZM9.75 2.5C7.40279 2.5 5.5 4.40279 5.5 6.75C5.5 8.30032 6.3301 9.65676 7.57007 10.3991C5.21752 11.2022 3.5 13.1398 3.5 15.5C3.5 15.7761 3.72386 16 4 16C4.27614 16 4.5 15.7761 4.5 15.5C4.5 13.0962 6.8732 11 10 11C12.0766 11 13.8532 11.9405 14.7866 13.2851C14.944 13.512 15.2556 13.5682 15.4824 13.4107C15.7093 13.2533 15.7655 12.9417 15.608 12.7149C14.8197 11.5792 13.5734 10.7172 12.0987 10.2926C13.2446 9.53136 14 8.22889 14 6.75C14 4.40279 12.0972 2.5 9.75 2.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.75 15C17.75 14.5858 17.4142 14.25 17 14.25C16.5858 14.25 16.25 14.5858 16.25 15V17.25H14C13.5858 17.25 13.25 17.5858 13.25 18C13.25 18.4142 13.5858 18.75 14 18.75H16.25V21C16.25 21.4142 16.5858 21.75 17 21.75C17.4142 21.75 17.75 21.4142 17.75 21V18.75H20C20.4142 18.75 20.75 18.4142 20.75 18C20.75 17.5858 20.4142 17.25 20 17.25H17.75V15Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Registration');

export default Icon;
